(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bw-shipping-details"]) return;
  try {
    
  (() => {
    if (window.bwShippingDetailsInitialized) return;
    window.bwShippingDetailsInitialized = true;
    let returnFocus;
    const bindDialog = () => {
      const dialog = document.getElementById('bw-shipping-dialog');
      if (!dialog || dialog.dataset.bwBound) return dialog;
      dialog.dataset.bwBound = 'true';
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('bw-shipping-is-open');
        if (returnFocus?.isConnected) returnFocus.focus({preventScroll: true});
      });
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      return dialog;
    };
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const opener = event.target.closest('[data-bw-shipping-open]');
      const closer = event.target.closest('[data-bw-shipping-close]');
      if (!opener && !closer) return;
      const dialog = bindDialog();
      if (!dialog || typeof dialog.showModal !== 'function') return;
      if (opener && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;
      event.preventDefault();
      event.stopPropagation();
      if (closer) { dialog.close(); return; }
      returnFocus = opener;
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('bw-shipping-is-open');
    }, true);
    const enhanceBanner = (root = document) => {
      const template = document.getElementById('bw-shipping-banner-template');
      if (!template) return;
      const wrappers = root.matches?.('.essential_free_shipping_bar_wrapper') ? [root] : [...root.querySelectorAll('.essential_free_shipping_bar_wrapper')];
      wrappers.forEach(wrapper => {
        const title = wrapper.querySelector('[class*="free_shipping_bar_title_"]');
        if (title && !title.querySelector('[data-bw-shipping-open]')) title.append(template.content.cloneNode(true));
      });
    };
    const start = () => {
      bindDialog();
      enhanceBanner();
      new MutationObserver(records => {
        const wrappers = new Set();
        for (const record of records) {
          if (record.target instanceof Element) {
            const wrapper = record.target.closest('.essential_free_shipping_bar_wrapper');
            if (wrapper) wrappers.add(wrapper);
          }
          for (const node of record.addedNodes) if (node instanceof Element && !node.matches('[data-bw-shipping-open]')) enhanceBanner(node);
        }
        wrappers.forEach(enhanceBanner);
      }).observe(document.body, {childList: true, subtree: true});
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
    document.addEventListener('shopify:section:load', () => { bindDialog(); enhanceBanner(); });
  })();

  } catch(e) { console.error(e); }
})();
})();
